export default __webpack_public_path__ + "static/media/ic-students.3291d856.svg";